import { render, staticRenderFns } from "./SynonymsRussianLanguage.vue?vue&type=template&id=b9cb3ccc&lang=pug&"
import script from "./SynonymsRussianLanguage.vue?vue&type=script&lang=js&"
export * from "./SynonymsRussianLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports